import { render, staticRenderFns } from "./TermsAndConditionsLinkButtons.vue?vue&type=template&id=4e386b3a&scoped=true&"
import script from "./TermsAndConditionsLinkButtons.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsLinkButtons.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsLinkButtons.vue?vue&type=style&index=0&id=4e386b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e386b3a",
  null
  
)

export default component.exports